import React, { useEffect, useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import CommentIcon from "@mui/icons-material/Comment";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import axiosMain from "../../../http/axios/axios_main";
import { useAuctionDetail } from "../../../components/common/AunctioneerDeteailProvider";
import SidebarContant from "../../../components/sidebar/sidebarcontent/SidebarContant";
import { Button, Card } from "react-bootstrap";
import CustomToast from "../../../components/Toast";

const currentDate = new Date().toISOString()?.split("T")[0];
const nextcurrentDate = new Date(); // Current date and time
nextcurrentDate.setDate(nextcurrentDate.getDate() + 1); // Add 1 day to the current date

const nextDate = nextcurrentDate.toISOString().split("T")[0]; // Format as "YYYY-MM-DD"
console.log(nextDate, "nextDate");

function EmailNotification({ handleClose }) {
  const [notificationList, setNotificationList] = useState([]);
  const [expanded, setExpanded] = useState("panel0");
  const [checked, setChecked] = React.useState([]);
  const {
    auctionDetailId,
    auctionCenterUserId,
    auctionCenterId,
    userId,
    auction,
    roleCode,
    auctionTypeMasterCode,
    userCode,
    auctionTypeMasterId,
    roleId,
  } = useAuctionDetail();

  // const handleToggle = (module, value) => () => {
  //   const currentIndex = checked
  //     .map((ele) => ele.notificationId)
  //     .indexOf(module.notificationId);

  //   const newChecked = [...checked];
  //   // debugger;
  //   if (
  //     currentIndex === -1 &&
  //     checked.map((ele) => ele.moduleid).indexOf(module.moduleid) === -1
  //   ) {
  //     newChecked.push({ ...module, isActive: 1 });
  //   } else {
  //     newChecked.splice(currentIndex, 1);
  //   }

  //   setChecked(newChecked);
  // };
  const handleToggle = (moduleId, notificationId, checked) => {
    setChecked((prevData) =>
      prevData.map((module) => {
        if (module.moduleid === moduleId) {
          return {
            ...module,
            notificationRolemappings: module.notificationRolemappings.map(
              (notification) => {
                if (notification.notificationId === notificationId) {
                  return { ...notification, isActive: checked ? 1 : 0 };
                }
                return notification;
              }
            ),
          };
        } else return module;
      })
    );
  };
  useEffect(() => {
    axiosMain
      .post("/admin/notification/get", {
        userId: userId,
        auctionCentersId: auctionCenterId,
        roleId: parseInt(roleId),
        roleCode: roleCode,
        auctionVarient: auctionTypeMasterId,
      })
      .then((res) => {
        if (res.data.statusCode === 200) {
          setChecked(
            res.data.responseData.modulesDtoList?.map((ele) => {
              return {
                ...ele,
                notificationRolemappings: ele.notificationRolemappings?.map(
                  (item) =>
                    item.isActive === null ? { ...item, isActive: 0 } : item
                ),
              };
            })
          );
          debugger;

          setNotificationList({
            ...res.data.responseData,
            modulesDtoList: res.data.responseData.modulesDtoList
              .map((ele) => {
                return SidebarContant?.map((item) =>
                  item.moduleId === ele.moduleid
                    ? { ...ele, moduleName: item.title }
                    : ""
                ).filter((ele) => ele !== "");
              })
              ?.reduce((curr, aqq) => curr.concat(aqq), []),
          });
          // console.log(
          //   res.data.responseData.modulesDtoList
          //     .map((ele) => {
          //       return SidebarContant?.map((item) =>
          //         item.moduleId === ele.moduleid
          //           ? { ...ele, moduleName: item.title }
          //           : ""
          //       ).filter((ele) => ele !== "");
          //     })
          //     ?.reduce((curr, aqq) => curr.concat(aqq), []),
          //   "dddddddddddddddddddddddddddd"
          // );
          // debugger;
        }
      })
      .catch((err) => console.log(err));
  }, []);
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  function handleSubmit(type) {
    // const selectedModuleList = checked?.map((ele) => {
    //   delete ele.usermappingId;
    //   return notificationList.modulesDtoList?.map((eleitem) =>
    //     eleitem.map((item) => item.module === ele.moduleid)
    //   );
    // });
    let data = notificationList?.modulesDtoList
      ?.map((ele, index) =>
        checked
          .map((eleitem) => (eleitem.moduleid === ele.moduleid ? ele : ""))
          ?.filter((item) => item !== "")
      )
      ?.reduce((cur, aqq) => cur.concat(aqq), []);

    // console.log(
    //   checked,
    //   data?.map((eleItems) => {
    //     return {
    //       ...eleItems,
    //       notificationRolemappings: eleItems.notificationRolemappings
    //         ?.map((ele, index) =>
    //           checked
    //             .map((eleitem) =>
    //               eleitem.notificationId === ele.notificationId ? ele : ""
    //             )
    //             ?.filter((item) => item !== "")
    //         )
    //         ?.reduce((cur, aqq) => cur.concat(aqq), []),
    //     };
    //   }),
    //   notificationList?.modulesDtoList
    //     ?.map((ele, index) =>
    //       checked
    //         .map((eleitem) => (eleitem.moduleid === ele.moduleid ? ele : ""))
    //         ?.filter((item) => item !== "")
    //     )
    //     ?.reduce((cur, aqq) => cur.concat(aqq), [])
    // );

    // console.log(notificationList?.modulesDtoList?.map((ele) => {
    //   return {
    //     ...ele,
    //     notificationRolemappings: ele.notificationRolemappings?.map(
    //       (item, index) => {
    //         delete item.usermappingId;
    //         return item;
    //       }
    //     ),
    //   };
    // }))
    console.log(checked);
    axiosMain
      .post("/admin/notification/create", {
        userId,
        auctionCentersId: type === "allCreate" ? 0 : auctionCenterId,
        roleId: parseInt(roleId),
        roleCode,
        auctionVarient: auctionTypeMasterId,
        modulesDtoList: checked.map((ele) => {
          delete ele.moduleName;
          return ele;
        }),
        // type === "allCreate"
        //   ? data?.map((eleItems) => {
        //       return {
        //         ...eleItems,
        //         notificationRolemappings: eleItems.notificationRolemappings
        //           ?.map((ele, index) => {
        //             delete ele.usermappingId;
        //             // ele.isActive = 1;
        //             return checked
        //               .map((eleitem) =>
        //                 eleitem.notificationId === ele.notificationId
        //                   ? ele
        //                   : ""
        //               )
        //               ?.filter((item) => item !== "");
        //           })
        //           ?.reduce((cur, aqq) => cur.concat(aqq), []),
        //       };
        //     })
        //   : data?.map((eleItems) => {
        //       return {
        //         ...eleItems,
        //         notificationRolemappings: eleItems.notificationRolemappings
        //           ?.map((ele, index) => {
        //             delete ele.usermappingId;
        //             // ele.isActive = 1;
        //             return checked
        //               .map((eleitem) =>
        //                 eleitem.notificationId === ele.notificationId
        //                   ? ele
        //                   : ""
        //               )
        //               ?.filter((item) => item !== "");
        //           })
        //           ?.reduce((cur, aqq) => cur.concat(aqq), []),
        //       };
        //     }),
      })
      .then((res) => {
        if (res.data.statusCode === 200) {
          CustomToast.success(res.data.message);
          handleClose(false);
        } else {
          CustomToast.error(res.data.message);
        }
      })
      .catch((err) => console.log(err));
  }
  return (
    <div>
      {notificationList?.modulesDtoList?.map((ele, indexs) => (
        <Accordion
          className={`${expanded === `panel${indexs}` ? "active" : ""}`}
          expanded={expanded === `panel${indexs}`}
          onChange={handleChange(`panel${indexs}`)}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Typography>{ele.moduleName}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Card key={indexs} className="w-100">
              <List
                sx={{
                  width: "100%",
                  maxWidth: 360,
                  bgcolor: "background.paper",
                }}
              >
                {checked
                  ?.at(indexs)
                  ?.notificationRolemappings?.map((item, index) => {
                    const labelId = `checkbox-list-label-${index}`;

                    return (
                      <Card.Body className="w-100 p-0">
                        <ListItem disablePadding>
                          <ListItemButton
                            // role={undefined}
                            onClick={() =>
                              handleToggle(
                                ele.moduleid,
                                item.notificationId,
                                item.isActive === 0
                              )
                            }
                            sx={{
                              py: 0,
                              minHeight: 32,
                              color: "rgba(255,255,255,.8)",
                            }}
                            // dense
                          >
                            <ListItemIcon>
                              <Checkbox
                                edge="start"
                                checked={item.isActive === 1}
                                tabIndex={-1}
                                disableRipple
                                inputProps={{ "aria-labelledby": labelId }}
                              />
                            </ListItemIcon>

                            <span className="modal-title text-dark">
                              {item.notificationName}
                            </span>
                          </ListItemButton>
                        </ListItem>
                      </Card.Body>
                    );
                  })}
              </List>
            </Card>
          </AccordionDetails>
        </Accordion>
      ))}
      <div className="BtnGroup justify-content-end mt-4">
        <Button className="SubmitBtn" onClick={() => handleSubmit("create")}>
          Submit
        </Button>
        <Button className="SubmitBtn" onClick={() => handleSubmit("allCreate")}>
        Apply to All Centers
        </Button>
      </div>
    </div>
  );
}

export default EmailNotification;
